import {authApiHeader} from "./AuthHeader";
const axios = require('axios').default;

const API_URL = process.env.REACT_APP_API_URL + "/api/promoCodeDataExport";

//Promo Code Data export
export const exportPromoCodes = () => {
    return axios.get(API_URL + "/basic", { headers: authApiHeader()});
};
